import { ILanguageItem, ILanguageItemContent } from './interfaces';

export class LanguageItem implements ILanguageItem {
  public static readonly DefaultSegmentName = '__default__';
  private readonly segments: Map<string, ILanguageItemContent> = new Map();

  public id: string;
  public description?: string;

  constructor(id: string, text: string | ILanguageItemContent, description?: string | null) {
    this.id = id;
    this.description = description ?? undefined;
    if (typeof text === 'string') {
      this.segments.set(LanguageItem.DefaultSegmentName, { source: text });
    } else {
      this.segments.set(LanguageItem.DefaultSegmentName, text);
    }
  }

  getSegments(): readonly string[] {
    return Array.from(this.segments.keys());
  }

  getSegment(segmentName: string | null = null): ILanguageItemContent | null {
    return this.segments.get(segmentName ?? LanguageItem.DefaultSegmentName) ?? null;
  }

  addSegment(segmentName: string, text: string | ILanguageItemContent): ILanguageItem {
    if (this.segments.has(segmentName)) {
      throw new Error(`Segment ${segmentName} already exists in translation item ${this.id}`);
    }
    if (typeof text === 'string') {
      text = { source: text };
    }
    this.segments.set(segmentName, text);
    return this;
  }
}
